<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	xmlns="http://www.w3.org/2000/svg"
	width="24"
	height="24"
	fill="none"
	viewBox="0 0 24 24"
>
	<path
		fill="currentColor"
		fill-rule="evenodd"
		d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm13.03-3.03c.3.3.3.77 0 1.06L13.06 12l1.97 1.97a.75.75 0 1 1-1.06 1.06L12 13.06l-1.97 1.97a.75.75 0 1 1-1.06-1.06L10.94 12l-1.97-1.97a.75.75 0 1 1 1.06-1.06L12 10.94l1.97-1.97c.3-.3.77-.3 1.06 0Z"
		clip-rule="evenodd"
	/>
</svg>
